import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import callApi from "Common/utils/apiCaller";
import BreadCrumb from "Common/BreadCrumb";
import { toast } from "react-toastify";
import { showNotification } from "Common/utils/Notification";
import { ToastContainer } from "react-toastify";
import ModuleData from "./ModulesData.json";
import PermissionData from "./PermissionData.json";
import LoaderComponent from "Common/Components/Loader/Loader";

const RoleUpdator = () => {
  const location = useLocation();
  const [loader, setLoader] = useState<any>(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [role, setRole] = useState<any>();

  //const [role, setRole] = useState(location.state?.role);
  const [userPermissions, setUserPermissions] = useState<string[]>([]);

  const [modules, setModules] = useState<string[]>([]);
  const [permissions, setPermissions] = useState<string[]>([]);

  const fetchModules = async () => {
    try {
      const result = await callApi("v1/modules/list", "post", {
        filters: {},
      });
      if (result.status === "Success") {
        setModules(result.data.moduleList.map((module: any) => module.code));
      } else {
        toast.error(result.data.message || "Failed to fetch modules.");
      }
    } catch (error) {
      toast.error("Error fetching modules.");
    }
  };

  const fetchPermissions = async () => {
    try {
      const result = await callApi("v1/permission/list", "post", {
        filters: {},
      });
      if (result.status === "Success") {
        setPermissions(
          result.data.permissionList.map((permission: any) => permission.code)
        );
      } else {
        toast.error(result.data.message || "Failed to fetch permissions.");
      }
    } catch (error) {
      toast.error("Error fetching permissions.");
    }
  };

  // const loadMockData = () => {
  //   const mockModules = ModuleData.map((module: any) => module.code);

  //   const mockPermissions = PermissionData.map(
  //     (permission: any) => permission.code
  //   );
  //   setModules(mockModules);
  //   setPermissions(mockPermissions);
  // };

  const togglePermission = (module: string, permission: string) => {
    const key = `${module}:${permission}`;
    setUserPermissions((prev) =>
      prev.includes(key) ? prev.filter((perm) => perm !== key) : [...prev, key]
    );
  };

  const savePermissions = async () => {
    try {
      setLoader(true);
      const result = await callApi(`v1/role/${id}/update`, "post", {
        role: {
          permissions: userPermissions,
        },
      });
      setLoader(false);
      if (result?.status === "Success") {
        showNotification("Permissions updated successfully!", "success");
        setLoader(true);
        setTimeout(() => {
          navigate("/roles");
          setLoader(false);
        }, 1000);
      }
    } catch (error) {
      showNotification("Failed to update permissions.", "error");
    }
  };

  const getRoles = async () => {
    try {
      const result = await callApi(`v1/role/${id}`, "get", {});

      if (result.status === "Success") {
        setUserPermissions(result.data.role.permissions);
        setRole(result.data.role);
      } else {
        toast.error(result.data.message || "Error updating permissions.");
      }
    } catch (error) {
      toast.error("Failed to update permissions.");
    }
  };

  useEffect(() => {
    // if (!role) {
    //   navigate("/admin/roles");
    //   return;
    // }
    getRoles();
    fetchModules();
    fetchPermissions();
    // loadMockData();
  }, []);

  // if (!role) {
  //   return <div>Loading...</div>;
  // }

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} limit={1} />
      <BreadCrumb title="Role Updator" pageTitle="Admin" version="" />
      <div className="card">
        <div className="card-body">
          <h1 className="mb-4 text-lg font-bold">{`Update Role: ${role?.name}`}</h1>
          <table className="w-full border border-collapse table-auto border-slate-300">
            <thead>
              <tr>
                <th className="px-4 py-2 border border-slate-300">Module</th>
                {permissions?.map((perm) => (
                  <th key={perm} className="px-4 py-2 border border-slate-300">
                    {perm?.charAt(0)?.toUpperCase() + perm?.slice(1)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {modules?.map((module) => (
                <tr key={module}>
                  <td className="px-4 py-2 border border-slate-300">
                    {module?.charAt(0).toUpperCase() + module?.slice(1)}
                  </td>
                  {permissions.map((permission) => {
                    const key = `${module}:${permission}`;
                    return (
                      <td
                        key={key}
                        className="px-4 py-2 text-center border border-slate-300"
                      >
                        <input
                          type="checkbox"
                          checked={userPermissions.includes(key)}
                          onChange={() => togglePermission(module, permission)}
                        />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex justify-end mt-4">
            <button
              className="mr-3 text-black bg-gray-300 btn"
              onClick={() => navigate("/roles")}
            >
              Cancel
            </button>
            <button
              className="text-white btn bg-custom-500"
              disabled={loader}
              style={{
                minWidth: "130px",
                display: "flex",
                justifyContent: "center",
              }}
              onClick={savePermissions}
            >
              {loader ? <LoaderComponent /> : "Save"}
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RoleUpdator;
